import React from 'react';

import { Link } from 'react-router-dom';

import { formatDisplayTitle } from './formatProductTitle';

import { useProducts } from './useProducts';

import { useSiteSettings } from './SiteSettingsContext';

import { giftFinderLinkLabel, isGiftFinderLinkVisible } from './giftFinder/giftFinderSettings';



/**

 * Shop menu items from live catalog categories (MySQL / JSON / static).

 */

export function ShopDropdownLinks({ onNavigate }) {

  const { categories, loading } = useProducts();

  const { settings } = useSiteSettings();

  const showGiftFinder = isGiftFinderLinkVisible(settings?.store_copy, 'nav');

  const sorted = [...categories].sort(

    (a, b) => a.sort_order - b.sort_order || a.slug.localeCompare(b.slug)

  );



  const close = () => onNavigate?.();



  if (loading) {

    return (

      <li>

        <span className="dropdown-item text-muted small">Loading…</span>

      </li>

    );

  }



  return (

    <>

      {sorted.map((c) => (

        <li key={c.slug}>

          <Link className="dropdown-item" to={`/shop/${c.slug}`} onClick={close}>

            {formatDisplayTitle(c.name || c.slug)}

          </Link>

        </li>

      ))}

      {showGiftFinder ? (

        <li>

          <Link className="dropdown-item" to="/gift-finder" onClick={close}>

            {giftFinderLinkLabel(settings?.store_copy, 'nav')}

          </Link>

        </li>

      ) : null}

      <li>

        <hr className="dropdown-divider" />

      </li>

      <li>

        <Link className="dropdown-item fw-semibold" to="/shop" onClick={close}>

          Shop overview

        </Link>

      </li>

    </>

  );

}


